import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Footer from './Footer';

const SygnPdfPage = () => {
  const navigate = useNavigate();
  const pdfUrl = "https://customer-assets.emergentagent.com/job_alans-resume/artifacts/ecbf0b7u_Sygn-Out-of-Home-Revenue-Share-Model.pdf";

  return (
    <div className="pdf-page">
      {/* Header */}
      <header className="pdf-header">
        <button onClick={() => navigate('/')} className="back-button">
          <ArrowLeft size={20} />
          <span>Back to Portfolio</span>
        </button>
        <h1 className="pdf-title">SYGN - Out of Home (OOH) Revenue Share Model</h1>
        <a href={pdfUrl} download className="download-button">
          Download PDF
        </a>
      </header>

      {/* PDF Viewer */}
      <div className="pdf-container">
        <iframe
          src={`${pdfUrl}#toolbar=1&navpanes=1&scrollbar=1`}
          title="SYGN Out of Home Revenue Share Model"
          className="pdf-viewer"
        />
      </div>
      
      <Footer />

      <style jsx>{`
        .pdf-page {
          min-height: 100vh;
          background: #151312;
          display: flex;
          flex-direction: column;
        }

        .pdf-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px 24px;
          background: #1e1c1b;
          border-bottom: 1px solid rgba(182, 180, 189, 0.1);
        }

        .back-button {
          display: flex;
          align-items: center;
          gap: 8px;
          background: transparent;
          border: 1px solid rgba(182, 180, 189, 0.3);
          color: #998f8f;
          padding: 10px 16px;
          border-radius: 8px;
          font-family: 'Poppins', sans-serif;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .back-button:hover {
          border-color: #f46c38;
          color: #f46c38;
        }

        .pdf-title {
          font-family: 'Poppins', sans-serif;
          font-size: 18px;
          font-weight: 600;
          color: #fff;
          margin: 0;
        }

        .download-button {
          display: inline-flex;
          align-items: center;
          background: #f46c38;
          color: #fff;
          padding: 10px 20px;
          border-radius: 8px;
          font-family: 'Poppins', sans-serif;
          font-size: 14px;
          font-weight: 500;
          text-decoration: none;
          transition: all 0.2s ease;
        }

        .download-button:hover {
          background: #e55a26;
        }

        .pdf-container {
          flex: 1;
          padding: 24px;
          display: flex;
          justify-content: center;
        }

        .pdf-viewer {
          width: 100%;
          max-width: 1200px;
          height: calc(100vh - 120px);
          border: none;
          border-radius: 8px;
          background: #fff;
        }

        @media (max-width: 768px) {
          .pdf-header {
            flex-direction: column;
            gap: 12px;
            padding: 16px;
          }

          .pdf-title {
            font-size: 14px;
            text-align: center;
          }

          .pdf-container {
            padding: 12px;
          }

          .pdf-viewer {
            height: calc(100vh - 180px);
          }
        }
      `}</style>
    </div>
  );
};

export default SygnPdfPage;
